var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('router-view',{staticClass:"mb-4",attrs:{"name":"navbar"}}),_c('router-view',{attrs:{"name":"sidebar"}}),_c('div',{staticClass:"content-wrapper p-2"},[_c('section',{staticClass:"content"},[_c('router-view')],1)]),_c('router-view',{attrs:{"name":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }